import angular from "angular";

angular
    .module('app')
    .component('courseSignUpForm', {
        template: require('./course-signup-form.html'),
        controller: ['$http', '$timeout', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, $timeout, Notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        console.log($ctrl.course);
        $ctrl.openGroup = $ctrl.course.groups[0];

        $ctrl.hasGroupSale = !!$ctrl.openGroup;
        $ctrl.hasSingleSale = !!$ctrl.course.open_single_sales;

        $ctrl.selectedType = $ctrl.openGroup ? 'group' : 'single';
    };

    $ctrl.signUp = function () {

        $ctrl.loading = true;

        $http
            .post(`/courses/${$ctrl.course.id}/sign-up`, {type: $ctrl.selectedType})
            .then(
                function (response) {
                    $ctrl.loading = false;
                    $ctrl.close();

                    Notifier.success('Вы успешно записались на курс', 2);
                },
                function (error) {
                    $ctrl.loading = false;
                    alert(error.data.message);
                }
            );
    };
}
